<div class="dialog-form">
    <form (keydown.enter)="$event.preventDefault()" novalidate>


        <div class="editor-container">
            <div class="message-section">
                <div class="form-group">
                    <div class="form-control" tooltipPosition="bottom"
                        pTooltip="Configure mensagens personalizadas do sistema" style="max-width: none!important;">
                        <label for="customMessage">{{ 'Mensagem personalizada' | translate }}</label>
                        <textarea [rows]="15" pInputTextarea autoResize="autoResize" name="customMessage"
                            [(ngModel)]="customMessage" placeholder="Digite a mensagem..."
                            class="message-textarea"
                            [class.invalid]="customMessage && !customMessage.trim()"
                            required></textarea>
                    </div>
                </div>
            </div>

            <div class="variables-section" *ngIf="availableVariables.length > 0">
                <div class="form-group">
                    <div class="form-control" tooltipPosition="bottom"
                        pTooltip="Clique para copiar e cole na sua mensagem. Elas serão substituídas pelos dados corretos no momento do envio.">
                        <label>{{ 'Variáveis disponíveis' | translate }}</label>
                        <div class="variables-list">
                            <div class="variable-item"
                                *ngFor="let variable of availableVariables"
                                (click)="insertVariable(variable.varName)"
                                [pTooltip]="variable.varName | translate"
                                tooltipPosition="left">
                                <span class="variable-name">{{ variable.varName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="buttons">
            <button type="button" class="easymarine danger" (click)="cancel()">
                {{ 'CANCEL' | translate }}
            </button>
            <button type="button" class="easymarine primary" (click)="save()">
                {{ 'SAVE' | translate }}
            </button>
        </div>
    </form>
</div>
